/*
 */
'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _tool = require("@entrylabs/tool");
var _event = _interopRequireDefault(require("@entrylabs/event"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0, _get2["default"])((0, _getPrototypeOf2["default"])(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
Entry.FieldKeyboard = /*#__PURE__*/function (_Entry$Field) {
  function FieldDropdown(content, blockView, index, renderMode, i, isDynamic) {
    var _this;
    (0, _classCallCheck2["default"])(this, FieldDropdown);
    _this = _callSuper(this, FieldDropdown);
    (0, _defineProperty2["default"])(_this, "keyboardControl", function (e) {
      e === null || e === void 0 || e.stopPropagation();
      e === null || e === void 0 || e.preventDefault();
      var value = Entry.Utils.inputToKeycode(e);
      if (!value) {
        return;
      }
      var text = Entry.getKeyCodeMap()[value];
      if (text !== undefined) {
        _this.destroyOption();
        _this.applyValue(value, false, true);
      }
    });
    if (isDynamic) {
      return (0, _possibleConstructorReturn2["default"])(_this);
    }
    _this._block = blockView.block;
    _this._blockView = blockView;
    _this.box = new Entry.BoxModel();
    _this.svgGroup = null;
    _this._contents = content;
    _this._noArrow = content.noArrow;
    var bgColor = content.bgColor,
      textColor = content.textColor;
    var arrowColor = content.arrowColor;
    var _this$_block = _this._block,
      deletable = _this$_block.deletable,
      emphasized = _this$_block.emphasized;
    if (deletable === Entry.Block.DELETABLE_FALSE_LIGHTEN || emphasized) {
      arrowColor = blockView._fillColor;
    }
    _this._arrowColor = arrowColor;
    _this._textColor = textColor || '#FFFFFF';
    _this._bgColor = bgColor;
    _this._index = index;
    _this.setValue(_this.getValue());
    _this._CONTENT_HEIGHT = _this.getContentHeight(content.dropdownHeight);
    _this._font_size = _this.getFontSize(content.fontSize);
    _this._ROUND = content.roundValue || 2;
    _this.renderStart();
    return _this;
  }
  (0, _inherits2["default"])(FieldDropdown, _Entry$Field);
  return (0, _createClass2["default"])(FieldDropdown, [{
    key: "renderStart",
    value: function renderStart() {
      var blockView = this._blockView;
      var X_PADDING = 20;
      var X_PADDING_SUBT = 10;
      var that = this;
      var CONTENT_HEIGHT = this._CONTENT_HEIGHT;
      var arrowInfo = this.getArrow();
      if (!this.svgGroup) {
        this.svgGroup = blockView.contentSvgGroup.elem('g', {
          "class": 'entry-field-dropdown'
        });
      }
      if (!this._header) {
        var rectInfo = {
          height: CONTENT_HEIGHT,
          y: -CONTENT_HEIGHT / 2,
          rx: that._ROUND,
          ry: that._ROUND
        };
        if (this._bgColor) {
          rectInfo.fill = this._bgColor;
        } else {
          rectInfo.fill = '#fff';
          rectInfo['fill-opacity'] = 0.4;
        }
        this._header = this.svgGroup.elem('rect', rectInfo);
      }
      if (!this.textElement) {
        this.textElement = this.svgGroup.elem('text', {
          x: 5,
          style: 'white-space: pre;',
          fill: this._textColor,
          'font-size': "".concat(+that._font_size, "px"),
          'font-weight': 'bold',
          'font-family': EntryStatic.fontFamily || 'NanumGothic'
        });
      }
      if (!this._noArrow && !this._arrow) {
        this._arrow = this.svgGroup.elem('path', {
          d: "M 5.79 0.818\n                L 3.339 3.8\n                a 0.5 0.5 0 0 1 -0.772 0\n                L 0.114 0.818\n                A 0.5 0.5 0 0 1 0.5 0\n                h 4.904\n                a 0.5 0.5 0 0 1 0.387 0.818\n                z\n                ",
          fill: arrowInfo.color,
          stroke: arrowInfo.color
        });
      }
      if (this instanceof Entry.FieldDropdownDynamic) {
        this._updateValue();
      }
      this._setTextValue();
      var bBox = this.getTextBBox();
      this.textElement.attr({
        y: bBox.height * 0.27
      });
      var width = bBox.width + X_PADDING;
      if (this._noArrow) {
        width -= X_PADDING_SUBT;
      }
      this._header.attr({
        width: width
      });
      if (!this._noArrow) {
        this._arrow.attr({
          transform: "translate(".concat(width - arrowInfo.width - 5, ",").concat(-arrowInfo.height / 2, ")")
        });
      }
      this._bindRenderOptions();
      this.box.set({
        x: 0,
        y: 0,
        width: width,
        height: CONTENT_HEIGHT
      });
      this.keyboardEvent = new _event["default"](document);
    }
  }, {
    key: "resize",
    value: function resize() {
      var X_PADDING = 20;
      var X_PADDING_SUBT = 10;
      var board = this._blockView.getBoard() || {};
      var _ref = board || {},
        _ref$scale = _ref.scale,
        scale = _ref$scale === void 0 ? 1 : _ref$scale;
      var width = this.textElement.getBoundingClientRect().width / scale + X_PADDING;
      if (!this._noArrow) {
        var arrowInfo = this.getArrow();
        this._arrow.attr({
          transform: "translate(".concat(width - arrowInfo.width - 5, ",").concat(-arrowInfo.height / 2, ")")
        });
      } else {
        width -= X_PADDING_SUBT;
      }
      this._header.attr({
        width: width
      });
      this.box.set({
        width: width
      });
      this._block.view.dAlignContent();
    }
  }, {
    key: "_attachDisposeEvent",
    value: function _attachDisposeEvent(func) {
      var _this2 = this;
      var action = func;
      if (!action) {
        action = function action(skipCommand) {
          _this2.destroyOption(skipCommand);
          _this2._selectBlockView();
        };
      }
      this.disposeEvent = Entry.disposeEvent.attach(this, action);
    }
  }, {
    key: "renderOptions",
    value: function renderOptions() {
      var _this3 = this;
      this.optionGroup = Entry.Dom('div', {
        "class": 'entry-widget-dropdown',
        parent: $('body')
      });
      var _this$_contents$optio = this._contents.options,
        options = _this$_contents$optio === void 0 ? [] : _this$_contents$optio;
      var convertedOptions = options.map(function (_ref2) {
        var _ref3 = (0, _slicedToArray2["default"])(_ref2, 2),
          key = _ref3[0],
          value = _ref3[1];
        return [_this3._convert(key, value), value];
      });
      this.dropdownWidget = new _tool.Dropdown({
        data: {
          eventTypes: ['mousedown', 'touchstart', 'wheel'],
          items: convertedOptions,
          positionDom: this.svgGroup,
          onOutsideClick: function onOutsideClick() {
            _this3.destroyOption();
          }
        },
        container: this.optionGroup[0]
      }).on('select', function (item) {
        _this3.applyValue(item[1]);
        _this3.destroyOption();
        $(_this3._blockView.contentSvgGroup).trigger('optionChanged', {
          block: _this3._block,
          value: _this3.getValue()
        });
      });
      this.optionDomCreated();
      this.keyboardEvent.on('keyup.keyboard', this.keyboardControl);
    }
  }, {
    key: "applyValue",
    value: function applyValue(value, skipCommand, forceCommand) {
      this.setValue(String(value));
      this._setTextValue();
      this.resize();
      this.destroyOption(skipCommand, forceCommand);
    }
  }, {
    key: "getTextByValue",
    value: function getTextByValue(value) {
      var reg = /&value/gm;
      if (reg.test(value)) {
        return value.replace(reg, '');
      }
      if (!value && typeof value !== 'number' || value === 'null') {
        return Lang.Blocks.no_target;
      }
      var matched = _.find(this._contents.options, function (_ref4) {
        var _ref5 = (0, _slicedToArray2["default"])(_ref4, 2),
          cValue = _ref5[1];
        return cValue == value;
      });
      if (matched) {
        return _.head(matched);
      }

      //no match found
      //check should return value as it is
      if (this._shouldReturnValue(value)) {
        return value;
      }
      return Lang.Blocks.no_target;
    }
  }, {
    key: "getContentHeight",
    value: function getContentHeight(height) {
      return height || this._blockView.getSkeleton().dropdownHeight || 20;
    }
  }, {
    key: "getArrow",
    value: function getArrow() {
      return {
        color: this._arrowColor || this._blockView._schema.color,
        points: '0,0 6.4,0 3.2,4.2',
        height: 4.2,
        width: 6.4
      };
    }
  }, {
    key: "_setTextValue",
    value: function _setTextValue() {
      var textValue = this.getTextByValue(this.getValue());
      var newValue = this._convert(textValue, this.getValue());
      if (this.getTextValue() !== newValue) {
        this.textElement.textContent = newValue;
      }
    }
  }, {
    key: "getTextValue",
    value: function getTextValue() {
      return this.textElement.textContent;
    }
  }, {
    key: "destroyOption",
    value: function destroyOption() {
      if (this.keyboardEvent) {
        this.keyboardEvent.off('keyboard');
      }
      if (this.dropdownWidget) {
        this.dropdownWidget.isShow && this.dropdownWidget.hide();
        this.dropdownWidget.remove();
        this.dropdownWidget = null;
      }
      if (this.optionGroup) {
        this.optionGroup.remove();
      }
      _superPropGet(FieldDropdown, "destroyOption", this, 3)([]);
    }
  }]);
}(Entry.Field);